// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid___-vlp","column":"style_column__1Rjo7","row":"style_row__3h5q5"};